import { render, staticRenderFns } from "./ChooseCurrencyWindow.vue?vue&type=template&id=668c654e&scoped=true&"
import script from "./ChooseCurrencyWindow.vue?vue&type=script&lang=js&"
export * from "./ChooseCurrencyWindow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "668c654e",
  null
  
)

export default component.exports